import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { Overview } from 'modules/trainings/components/TrainingDetail/Overview'

export default function OverviewPage() {
  return (
    <ResponsivePage.Body>
      <Overview />
    </ResponsivePage.Body>
  )
}
